import { createMuiTheme } from '@material-ui/core'

import {
  greys,
  primaryColor,
  primaryColorLight,
  primaryColorDark,
  primaryColorContrastText,
  secondaryColor,
  secondaryColorLight,
  secondaryColorDark,
  secondaryColorContrastText
} from './variables'

export default createMuiTheme({
  props: {
    MuiAppBar: {
      elevation: 0
    },
    MuiButton: {
      color: 'primary',
      variant: 'outlined'
    },
    MuiInput: {
      disableUnderline: true
    },
    MuiInputLabel: {
      shrink: true
    },
    MuiModal: {
      BackdropProps: {
        transitionDuration: 500
      }
    },
    MuiPopover: {
      elevation: 0
    },
    MuiTypography: {
      headlineMapping: {
        h1: 'p',
        h2: 'p',
        h3: 'p',
        h4: 'p',
        h5: 'p',
        h6: 'p',
        subtitle1: 'h6',
        subtitle2: 'h6',
        display4: 'h1',
        display3: 'h1',
        display2: 'h1',
        display1: 'h1',
        headline: 'h1',
        title: 'span',
        subheading: 'h3'
      }
    }
  },

  overrides: {
    MuiAppBar: {
      root: {
        padding: 0
      }
    },
    MuiButton: {
      root: {
        color: greys[900],
        fontWeight: 'bold'
      }
      // containedSecondary: {
      //   color: secondaryColorContrastText
      // },
      // outlined: {
      //   borderColor: secondaryColor,
      //   transition: 'background-color 0.2s, color 0.2s',

      //   '&:hover': {
      //     color: secondaryColorContrastText,
      //     backgroundColor: secondaryColor
      //   }
      // }
    },
    MuiCard: {
      root: {
        borderColor: greys[100],
        borderRadius: '10px',
        borderStyle: 'solid',
        borderWidth: '1px',
        boxShadow: `0px 3px 5px ${greys[200]}`
      }
    },
    MuiFormControl: {
      root: {
        boxSizing: 'border-box',
      }
    },
    MuiFormLabel: {
      root: {
        color: primaryColorDark,
        '&$focused': {
          color: primaryColorDark
        }
      }
    },
    MuiIconButton: {
      root: {
        padding: 0,
        fontSize: 10
        // borderRadius: '8px',
        // boxShadow: '0px 2px 3px rgba(0,0,0,0.15)',
      }
    },
    MuiInput: {
      root: {
        borderColor: greys['300'],
        borderRadius: '3px',
        borderStyle: 'solid',
        borderWidth: '1px',
        boxSizing: 'border-box'
      },
      underline: {
        border: '0'
      }
    },
    MuiInputAdornment: {
      root: {
        borderRightColor: greys['300'],
        borderRightWidth: '1px',
        borderRightStyle: 'solid',
        color: greys['300'],
        paddingRight: '14px'
      }
    },
    MuiInputLabel: {
      root: {
        '&$shrink': {
          transform: 'translate(0, -4px) scale(1)'
        }
      },
      shrink: {}
    },
    MuiMenu: {
      paper: {
        padding: 0
      }
    },
    MuiPaper: {
      root: {
        padding: 12
        // borderColor: variables['lightGray'],
      }
    },
    MuiPopover: {
      paper: {
        borderColor: greys['300'],
        borderStyle: 'solid',
        borderWidth: '1px'
      }
    },
    MuiStepIcon: {
      root: {
        '&$active': {
          color: secondaryColor
        }
      },
      active: {}
    },
    MuiSvgIcon: {
      fontSizeSmall: {
        fontSize: '24px'
      },
      root: {
        fontSize: '40px'
      },
      fontSizeLarge: {
        fontSize: '62px'
      }
    },
    MuiTab: {
      root: {
        '&$selected': {
          fontWeight: 'bold'
        }
      },
      label: {
        fontSize: '1rem !important'
      },
      selected: {}
    },
    MuiTableCell: {
      head: {
        // color: variables['overrides_MuiTableCell_head_color'],
        fontWeight: 'bold'
      },
      root: {
        // borderBottomColor: variables['palette_divider'],
        fontSize: '1rem !important'
      }
    },
    MuiTableHead: {
      root: {
        // borderBottomColor: variables['overrides_MuiTableHead_root_borderColor'],
        borderBottomStyle: 'solid',
        borderBottomWidth: '2px'
      }
    },
    MuiTabs: {
      root: {
        // borderBottomColor: variables['overrides_MuiTabs_root_borderColor'],
        borderBottomStyle: 'solid',
        borderBottomWidth: '1px'
      }
    },
    MuiTypography: {
      colorPrimary: {
        color: primaryColorContrastText
      },
      colorSecondary: {
        color: secondaryColorContrastText
      },
      title: {
        fontSize: '24px',
        fontWeight: 'bold'
      }
    }
  },

  palette: {
    background: {
      default: greys[100]
    },
    grey: greys,
    primary: {
      dark: primaryColorDark,
      light: primaryColorLight,
      main: primaryColor,
      contrastText: primaryColorContrastText
    },
    secondary: {
      dark: secondaryColorDark,
      light: secondaryColorLight,
      main: secondaryColor,
      contrastText: secondaryColorContrastText
    },
    text: {
      primary: greys[900],
      secondary: greys[500]
    }
  },

  typography: {
    useNextVariants: true,
    fontFamily: '"Open Sans", sans-serif',
    h1: {
      fontFamily: 'Open Sans'
    },
    h2: {
      fontFamily: 'Open Sans'
    },
    h3: {
      fontFamily: 'Open Sans'
    },
    h4: {
      fontFamily: 'Open Sans'
    },
    h5: {
      fontFamily: 'Open Sans'
    },
    h6: {
      fontFamily: 'Open Sans'
    }
  }
})
